<script setup>
import { inject } from 'vue'

defineProps({
  item: {
    type: Object,
    required: true
  }
})

const checkSubscription = inject('checkSubscription')
</script>

<template>
  <div :class="{ 'blur-md select-none py-2': checkSubscription(item) }">
    <span class="text-sm text-gray-500 not-italic capitalize">
      {{ checkSubscription(item) ? 'Secret text' : item.value }}
    </span>
  </div>
</template>